import React, { useState } from "react";
import { Slider } from "../components/ui/slider";

const EarningsCalculator = () => {
  const [sliderValue, setSliderValue] = useState([50]);

  // Calculate commission and earnings based on slider value (0-100)
  // Low (0) → 2% / 250 kr, Medium (50) → 5% / 650 kr, High (100) → 10% / 1300 kr
  const calculateEarnings = (value) => {
    // Commission: 2% at 0, 10% at 100 (smooth progression)
    const commission = 2 + (value / 100) * 8;
    
    // Estimated earnings: 250 kr at 0, 1300 kr at 100
    const earnings = 250 + (value / 100) * 1050;
    
    return {
      commission: Math.round(commission),
      earnings: Math.round(earnings / 50) * 50, // Round to nearest 50
    };
  };

  const { commission, earnings } = calculateEarnings(sliderValue[0]);

  // Format earnings with space as thousand separator
  const formatEarnings = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  return (
    <section
      id="calculator"
      className="py-20 md:py-28 bg-[#0A0A0A]"
      data-testid="earnings-calculator-section"
    >
      <div className="max-w-xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-white font-['Outfit'] mb-4">
            Hva kan du tjene?
          </h2>
          <p className="text-base text-[#A1A1AA]">
            Jo bedre lokasjonen er, desto høyere provisjon kan du få –{" "}
            <span className="text-[#FFD84D] font-semibold">opptil 10%</span>.
          </p>
        </div>

        {/* Calculator Card */}
        <div className="bg-[#121212] border border-white/10 rounded-2xl p-6 md:p-8">
          {/* Results Display */}
          <div className="grid grid-cols-2 gap-4 mb-8">
            <div className="text-center py-5 px-4 bg-[#0A0A0A] rounded-xl border border-white/5">
              <p className="text-xs text-[#A1A1AA] mb-1">Din provisjon</p>
              <div className="text-3xl md:text-4xl font-bold text-[#FFD84D] font-['Outfit']">
                {commission}%
              </div>
            </div>
            <div className="text-center py-5 px-4 bg-[#0A0A0A] rounded-xl border border-white/5">
              <p className="text-xs text-[#A1A1AA] mb-1">Estimert inntekt</p>
              <div className="text-3xl md:text-4xl font-bold text-white font-['Outfit']">
                {formatEarnings(earnings)}
                <span className="text-sm text-[#A1A1AA] font-normal ml-1">kr/mnd</span>
              </div>
            </div>
          </div>

          {/* Slider */}
          <div className="mb-6">
            <label className="block text-sm text-[#A1A1AA] mb-4 text-center">
              Lokasjonens potensial
            </label>
            <Slider
              value={sliderValue}
              onValueChange={setSliderValue}
              max={100}
              step={1}
              className="w-full [&_[role=slider]]:bg-[#FFD84D] [&_[role=slider]]:border-[#FFD84D] [&_[role=slider]]:w-5 [&_[role=slider]]:h-5 [&_[role=slider]]:shadow-[0_0_12px_rgba(255,216,77,0.4)] [&_[role=slider]]:hover:shadow-[0_0_16px_rgba(255,216,77,0.6)] [&_[role=slider]]:transition-shadow [&_.bg-primary]:bg-[#FFD84D]"
              data-testid="earnings-slider"
            />
            <div className="flex justify-between mt-2">
              <span className="text-xs text-[#A1A1AA]">Lavt</span>
              <span className="text-xs text-[#A1A1AA]">Høyt</span>
            </div>
          </div>

          {/* Disclaimer */}
          <p className="text-xs text-[#A1A1AA]/60 text-center">
            Beløpene er estimater og ingen garanti. Faktisk provisjon vurderes individuelt ut fra lokasjon, bidrag og avtale.
          </p>
        </div>
      </div>
    </section>
  );
};

export default EarningsCalculator;
